/**
 * The context object and its hook, split out of TourProvider.jsx.
 *
 * Two reasons, both real:
 *   1. It breaks a CYCLE. TourProvider renders TourOverlay and TourLauncher, and both of them need
 *      useTour — so importing it from TourProvider made those three modules a circular graph. ESM
 *      tolerates that until it doesn't, and when it doesn't the symptom is an undefined import at
 *      module-init, which reads like anything except an import cycle.
 *   2. A file that exports both a component and a hook trips react-refresh/only-export-components,
 *      and the lint ratchet in CI has zero headroom.
 */
import { createContext, useContext } from 'react'

export const TourContext = createContext(null)

export const useTour = () => {
  const ctx = useContext(TourContext)
  if (!ctx) throw new Error('useTour must be used within a TourProvider')
  return ctx
}
